import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import TrackingDetailsFlightInfo from './../TrackingDetailsFlightInfo/TrackingDetailsFlightInfo';
import BackgroundColorMobile from './../BackgroundColorMobile/BackgroundColorMobile';
import {requestShipmentDetailsData} from "../../actions/shipmentDetailsDataActions";
import {getHours, getAMorPM, formatDateString, dateEqualsToday, dateEqualsTomorrow, dateEqualsYesterday} from '../../shared/dateFormatter';
import {getLotStatus} from '../../shared/lotStatus';
import {getDescriptionForAWBStatus, getCSSForAWBStatus} from '../../shared/awbStatus';
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import {fetchScanStatusData} from "../../api/scanStatusDataApi";

class TrackingDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shipmentDetails: {},
            lotInformation: [],
            lineInformation: [],
            lineInfoTotals: {},
            deliveryInfo: {},
            airWaybillStepperInfo: {},
            flightDetailScans: {}
        };
    }

    componentDidMount() {
        const querystringParams = queryString.parse(this.props.location.search);
        const trackingIdParam = querystringParams.trackingId;
        if (trackingIdParam !== undefined) {
            const index = trackingIdParam.indexOf('-');
            const trackingInfoToSend = [{
                airlineCode: trackingIdParam.substr(0, index),
                trackingNumber: trackingIdParam.substr(index + 1, trackingIdParam.length)
            }];
            this.props.requestShipmentDetailsData(trackingInfoToSend);
            if (!this.props.rawFacilities) {
                this.props.getRawFacilities();
            }
        }
    }

    buildViewModel = () => {
        if (Object.keys(this.props.shipmentDetailsData).length === 0) {
            return;
        }
        const shipmentDetails = {
            trackingId: this.props.shipmentDetailsData.awbPrefix + ' ' + this.props.shipmentDetailsData.awbNumber,
            awbStatus: this.props.shipmentDetailsData.awbStatus,
            serviceLevel: this.props.shipmentDetailsData.serviceLevel ? this.props.shipmentDetailsData.serviceLevel.description : null,
            destinationCode: this.props.shipmentDetailsData.destination ? this.props.shipmentDetailsData.destination.code : null,
            originCode: this.props.shipmentDetailsData.origin ? this.props.shipmentDetailsData.origin.code : null,
            shipperName: this.props.shipmentDetailsData.shipperName,
            shipperAddressLine1: this.props.shipmentDetailsData.shipperAddress ? this.props.shipmentDetailsData.shipperAddress.addressLine : null,
            shipperAddressLine2: this.props.shipmentDetailsData.shipperAddress ? this.props.shipmentDetailsData.shipperAddress.addressLine2 : null,
            shipperAddressCityState: this.props.shipmentDetailsData.shipperAddress ? this.props.shipmentDetailsData.shipperAddress.city : null,
            consigneeName: this.props.shipmentDetailsData.consigneeName,
            consigneeAddressLine1: this.props.shipmentDetailsData.consigneeAddress ? this.props.shipmentDetailsData.consigneeAddress.addressLine : null,
            consigneeAddressLine2: this.props.shipmentDetailsData.consigneeAddress ? this.props.shipmentDetailsData.consigneeAddress.addressLine2 : null,
            consigneeAddressCityState: this.props.shipmentDetailsData.consigneeAddress ? this.props.shipmentDetailsData.consigneeAddress.city : null
        };

        if (this.props.shipmentDetailsData.shipperAddress && this.props.shipmentDetailsData.shipperAddress.state) {
            shipmentDetails.shipperAddressCityState = shipmentDetails.shipperAddressCityState + ", " +
                    this.props.shipmentDetailsData.shipperAddress.state
        }

        if (this.props.shipmentDetailsData.consigneeAddress && this.props.shipmentDetailsData.consigneeAddress.state) {

            shipmentDetails.consigneeAddressCityState = shipmentDetails.consigneeAddressCityState + ", " + this.props.shipmentDetailsData.consigneeAddress.state;
            shipmentDetails.consigneeAddressCityState = shipmentDetails.consigneeAddressCityState + " " +
                    this.props.shipmentDetailsData.consigneeAddress.zipCode;
        }

        let lots = [];
        let lotId = 1;
        let legId = 1;
        let allLegs = [];
        this.props.shipmentDetailsData.routeInformations = this.props.shipmentDetailsData.routeInformations || [];
        this.props.shipmentDetailsData.routeInformations.forEach(lot => {
            let legs = [];
            let legNumber = 1;
            lot.flightlegTypes.forEach((leg, index, array) => {
                let isLastLeg = false;
                if (index === array.length - 1) {
                    isLastLeg = true;
                }
                const legInfo = {
                    id: legId,
                    legNumber: legNumber,
                    legName: 'Leg ' + legNumber,
                    airlineCode: leg.carrierCode.code,
                    flight: leg.flightNumber,
                    origin: leg.origin.code,
                    destination: leg.destination.code,
                    scheduledDepart: leg.schedDepDateTime,
                    estimatedDepart: leg.estDepDateTime,
                    scheduledArrival: leg.schedArrDateTime,
                    estimatedArrival: leg.estArrDateTime,
                    isLastLeg: isLastLeg
                };
                legs.push(legInfo);
                allLegs.push(legInfo);
                legNumber++;
                legId++;
            });

            const lotInfo = {
                id: lotId,
                lotNumber: lot.lotNumber,
                name: 'Lot ' + lot.lotNumber,
                statusRaw: lot.currentLotStatus,
                status: getLotStatus(lot.currentLotStatus),
                pieces: lot.noOfPieces,
                actualWeight: lot.actualWeight,
                flightLegs: legs,
                receivedDateRaw: lot.receivedDate,
                receivedDate: (lot.receivedDate !== null) ? new Date(lot.receivedDate) : null,
                pickedDateRaw: lot.deliveredDate,
                pickedDate: (lot.deliveredDate !== null) ? new Date(lot.deliveredDate) : null,
                signedBy: lot.deliveredToCustomer,
                shipmentTransitTime: lot.shipmentTransitTime,
                reroutingReason: lot.reroutingReason
            };
            lots.push(lotInfo);
            lotId++;

        });

        this.getDeliveryInformation(lots);

        let lineInfo = [];
        let lineInfoId = 1;
        let totalPieces = 0;
        let totalDimensionalWeight = 0;
        let totalActualWeight = 0;
        let totalActualWeightUOM = '';
        let totalSlac = 0;

        this.props.shipmentDetailsData.lineInformations = this.props.shipmentDetailsData.lineInformations || [];

        this.props.shipmentDetailsData.lineInformations.forEach(info => {
            const dimensionUnitOfMeasure = this.getUnitOfMeasure(info.dimensionUOM);
            const line = {
                id: lineInfoId,
                description: info.contentDesc.name,
                pieces: info.pieces,
                slac: info.slac,
                actualWeight: info.actualWeight,
                actualWeightUOM: info.actualWeightUOM,
                length: info.length,
                width: info.width,
                height: info.height,
                dimensionUnitOfMeasure: dimensionUnitOfMeasure,
                dimensionalWeight: info.dimensionWeight
            };
            lineInfo.push(line);
            lineInfoId++;
            totalPieces += info.pieces;
            totalDimensionalWeight += info.dimensionWeight;
            totalActualWeight += info.actualWeight;
            totalActualWeightUOM = info.actualWeightUOM;
            totalSlac += info.slac;
        });

        const totals = {
            totalPieces: totalPieces,
            totalDimensionalWeight: totalDimensionalWeight,
            totalActualWeight: ((totalActualWeight).toFixed(1)),
            totalActualWeightUOM: totalActualWeightUOM,
            totalSlac: totalSlac
        };
        const deliveryInfo = this.getDeliveryInformation(lots);
        const airWaybillStepperInfo = {
            awbPrefix: this.props.shipmentDetailsData.awbPrefix,
            airWaybillNumber: this.props.shipmentDetailsData.awbNumber,
            isoCreateDate: this.props.shipmentDetailsData.isoCreateDate,
            bookingCompletionDate: this.props.shipmentDetailsData.bookingCompletionDate,
            awbCreateDate: this.props.shipmentDetailsData.awbCreateDate,
            tenderedDate: this.props.shipmentDetailsData.tenderedDate,
            manifestedDate: this.props.shipmentDetailsData.manifestDate,
            travelTime: this.getTravelTime(lots),
            receivedDate: deliveryInfo.maxReceivedDate,
            deliveredDate: deliveryInfo.maxPickedDate,
            deliveredTo: deliveryInfo.pickedBy
        };


        let flightDetailsObj =  {
            "awbPrefix": airWaybillStepperInfo.awbPrefix,
            "airWaybillNumber": airWaybillStepperInfo.airWaybillNumber,
            "isoCreateDate": this.props.shipmentDetailsData.isoCreateDate
        }

        fetchScanStatusData(flightDetailsObj).then(response => {
            this.setState({ flightDetailScans: response });
        });

        this.setState({
            shipmentDetails: shipmentDetails,
            lotInformation: lots,
            lineInformation: lineInfo,
            lineInfoTotals: totals,
            deliveryInfo: deliveryInfo,
            airWaybillStepperInfo: airWaybillStepperInfo,
            legs: allLegs
        });


    };

    getCityAndState = (code) => {
        if (this.props.rawFacilities === undefined || this.props.rawFacilities === null)
            return;

        const facility = this.props.rawFacilities.find(element => element.airportCodeIATA === code);
        if (facility === null || facility === undefined || facility.facilityInfo === null || facility.facilityInfo.location === null)
            return;

        return this.formatCity(facility.facilityInfo.location.cityName) + ', ' + facility.facilityInfo.location.stateName.toUpperCase();

    };

    formatCity = city => {
        if (city.length > 0) {
            let formattedCity = '';
            city.split(" ").forEach(function (item) {
                formattedCity += item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() + ' ';
            });
            return formattedCity.substr(0, formattedCity.length - 1);
        }
    };

    getUnitOfMeasure = (unitOfMeasure) => {
        if (unitOfMeasure === null || unitOfMeasure === undefined)
            return;
        if (unitOfMeasure.length === 0)
            return;
        return ' ' + unitOfMeasure.toLowerCase();
    };

    getDeliveryInformation = (lots) => {
        let isReceivedByNull = false;
        let isPickedUpNull = false;
        let maxReceivedDate = null;
        let maxPickedDate = null;
        let pickedBy = null;

        lots.forEach(lot => {
            if (lot.receivedDate === null)
                isReceivedByNull = true;
            if (lot.pickedDate === null) {
                isPickedUpNull = true;
            }
        });

        if (isReceivedByNull === false) {
            const sortedLotsByReceivedDate = lots.sort(function (a, b) {
                        return b['receivedDate'] - a['receivedDate'];
                    })
            ;
            maxReceivedDate = sortedLotsByReceivedDate[sortedLotsByReceivedDate.length - 1] ? sortedLotsByReceivedDate[sortedLotsByReceivedDate.length - 1].receivedDateRaw : null;
        }

        if (isPickedUpNull === false) {
            const sortedLotsByPickedDate = lots.sort(function (a, b) {
                        return b['pickedDate'] - a['pickedDate'];
                    })
            ;
            maxPickedDate = sortedLotsByPickedDate[sortedLotsByPickedDate.length - 1] ? sortedLotsByPickedDate[sortedLotsByPickedDate.length - 1].pickedDateRaw : null;
            pickedBy = sortedLotsByPickedDate[sortedLotsByPickedDate.length - 1] ? sortedLotsByPickedDate[sortedLotsByPickedDate.length - 1].deliveredToCustomer : null;
        }
        return {
            maxReceivedDate: maxReceivedDate,
            maxPickedDate: maxPickedDate,
            pickedBy: pickedBy
        };
    };

    getTravelTime = (lots) => {
        if (lots.length > 0) {
            const sortedLotsByShipperTransitTime = lots.sort(function (a, b) {
                return b['shipmentTransitTime'] - a['shipmentTransitTime'];
            });
            return sortedLotsByShipperTransitTime[0].shipmentTransitTime;
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.shipmentDetailsData.awbNumber !== this.props.shipmentDetailsData.awbNumber ||
                Object.keys(this.state.shipmentDetails).length === 0) {
            this.buildViewModel();
        }
    }

    getCSSForLotSepertaorSmallScreen = (id) => {

        if (id < this.state.lotInformation.length)
            return 'tracking-details-lot-seperator';
    };

    getDateStringFromRawDate = (dateString) => {
        if (dateString === undefined || dateString === null || dateString.length === 0)
            return;
        const index = dateString.indexOf(' ');
        return dateString.substr(0, index);
    };

    getTimeStringFromRawDate = (dateString) => {
        if (dateString === undefined || dateString === null || dateString.length === 0)
            return;
        const index = dateString.indexOf(' ');
        return dateString.substr(index + 1, dateString.length);
    };

    getCSSForLastLeg = (isLastLeg) => {
        if (isLastLeg === true) {
            return 'tracking-details-lot-details-wrapper tracking-details-last-leg'

        }
        return 'tracking-details-lot-details-wrapper';
    };

    getCSSForLastLegMobile = (islastLeg) => {
        let cssClass = 'tracking-details-lot-details-with-legs-wrapper';
        if (islastLeg === true)
            cssClass += ' tracking-details-lot-details-with-legs-wrapper__last';
        return cssClass;
    };

    getFlightLink = (leg) => {
        if (dateEqualsToday(leg.scheduledDepart) ||
                dateEqualsTomorrow(leg.scheduledDepart) ||
                dateEqualsYesterday(leg.scheduledDepart)) {
            let scheduledDepart = formatDateString(leg.scheduledDepart, "YYYY-MM-DD");
            let swaUrl = "https://www.southwest.com/air/flight-schedules/path.html?departureDate=" + scheduledDepart + "&flightNumber=" + leg.flight;
            return <a href={swaUrl} target={"_blank"}>{leg.airlineCode + leg.flight}</a>;
        } else {
            return leg.airlineCode + leg.flight;
        }
    }

    getFacilityLink = (facility) => {
        return "/ship/facilities/facility?airportCode=" + facility;
    }

    render() {

        let destinationLocation;
        let destinationLocationCityState;
        let originLocation;
        let originLocationCityState;

        if (this.props.rawFacilities) {

            destinationLocation = this.props.rawFacilities ? this.props.rawFacilities.filter((item) => {
                return item.airportCodeIATA === this.state.shipmentDetails.destinationCode
            })[0] : null;

            if (!destinationLocation) {
                destinationLocationCityState = "";
            } else {
                destinationLocationCityState = destinationLocation.airportCodeIATA + " - " + destinationLocation.commonAirportName;
            }

            originLocation = this.props.rawFacilities ? this.props.rawFacilities.filter((item) => {
                return item.airportCodeIATA === this.state.shipmentDetails.originCode
            })[0] : null;

            if (!originLocation) {
                originLocationCityState = "";
            } else {
                originLocationCityState = originLocation.airportCodeIATA + " - " + originLocation.commonAirportName;
            }
        }

        return (
                <div className="tracking-details-wrapper">

                    <div className="tracking-details-tracking-inner-container">
                        <div className="tracking-details-tracking__header">
                            <span className="tracking-details-header-tracking__label"> Tracking Detail: </span>
                            {this.state.shipmentDetails.trackingId}
                        </div>
                        <div className="tracking-details-button__header">
                            <button type="submit" className="print-transparent" onClick={() => window.print()}>
                                <span className="tracking-details-medium-to-small-header-panel-button__text"> Print Tracking </span>
                            </button>
                            <button type="submit" className="track-additional-transparent" onClick={() => window.location.href = "./manage/tracking"}>
                                <span className="tracking-details-medium-to-small-header-panel-button__text"> Track Another Shipment </span>
                            </button>
                        </div>
                    </div>

                    <div className="tracking-details-medium-to-small-header-wrapper">
                        <div className="tracking-details-header-tracking__label">Tracking Detail</div>
                        <p className="tracking-details-header-air-waybill__label text-uppercase mtm">Air Waybill</p>
                        <p className="tracking-details-header-air-waybill mtm"> {this.state.shipmentDetails.trackingId} </p>
                    </div>
                    <div className="tracking-details-medium-to-small-header-panel-button">
                        <button type="submit" className="print-transparent" onClick={() => window.print()}>
                            <span className="tracking-details-medium-to-small-header-panel-button__text"> Print Tracking </span>
                        </button>
                        <button type="submit" className="track-additional-transparent" onClick={() => window.location.href = "./manage/tracking"}>
                            <span className="tracking-details-medium-to-small-header-panel-button__text"> Track Another Shipment </span>
                        </button>
                    </div>

                    <div className={getCSSForAWBStatus(this.state.shipmentDetails.awbStatus)}>
                        <div className="tracking-details-status-destination_inline">
                            <div className="tracking-details-status-and-service__label text-uppercase">AIR WAYBILL STATUS</div>
                            <div className="tracking-details-status-and-service__text"> {getDescriptionForAWBStatus(this.state.shipmentDetails.awbStatus)}</div>
                        </div>
                        <div className="tracking-details-status__spacer"/>
                        <div className="tracking-details-status-destination_inline">
                            <div className="tracking-details-status-and-service__label text-uppercase tracking-details-destination_label">Origin</div>
                            <div className="tracking-details-status__city"> {originLocationCityState}</div>
                        </div>
                        <div className="tracking-details-status__spacer"/>
                        <div className="tracking-details-status-destination_inline">
                            <div className="tracking-details-status-and-service__label text-uppercase tracking-details-destination_label">Destination</div>
                            <div className="tracking-details-status__city"> {destinationLocationCityState}</div>
                        </div>
                    </div>

                    <div
                            className="tracking-details-status-and-service__wrapper tracking-details-status-and-service-background__blue">
                        <div className="tracking-details-status-and-service__label text-uppercase"> SERVICE Level</div>
                        <div
                                className="tracking-details-status-and-service__text text-uppercase"> {this.state.shipmentDetails.serviceLevel} </div>
                    </div>


                    <div className="tracking-details-inner-container">
                        <div className="tracking-details-flight-info-wrapper">
                            <TrackingDetailsFlightInfo
                                    tenderedDate={this.state.airWaybillStepperInfo.tenderedDate}
                                    manifestedDate={this.state.airWaybillStepperInfo.manifestedDate}
                                    travelTime={this.state.airWaybillStepperInfo.travelTime}
                                    receivedDate={this.state.airWaybillStepperInfo.receivedDate}
                                    deliveredDate={this.state.airWaybillStepperInfo.deliveredDate}
                                    deliveredTo={this.state.airWaybillStepperInfo.deliveredTo}
                                    isoCreateDate={this.state.airWaybillStepperInfo.isoCreateDate}
                                    bookingCompletionDate={this.state.airWaybillStepperInfo.bookingCompletionDate}
                                    airWaybillNumber={this.state.airWaybillStepperInfo.airWaybillNumber}
                                    awbPrefix={this.state.airWaybillStepperInfo.awbPrefix}
                                    awbCreateDate={this.state.airWaybillStepperInfo.awbCreateDate}
                                    legs={this.state.legs}
                                    numLots={this.state.lotInformation.length}
                                    flightDetailScans = {this.state.flightDetailScans.scanStatuses}
                            />
                        </div>


                        <div className="tracking-details-other-info-wrapper">

                            <div className="tracking-details-shipper">
                                <div className="tracking-details-title-label"> Shipper</div>
                                <div className="tracking-details-shipper-consignee-info-wrapper">
                                    {this.state.shipmentDetails.shipperName}
                                </div>
                            </div>

                            <div className="tracking-details-consignee">
                                <div className="tracking-details-title-label"> Consignee</div>
                                <div className="tracking-details-shipper-consignee-info-wrapper text-uppercase">
                                    {this.state.shipmentDetails.consigneeName}
                                </div>
                            </div>

                            <div className="tracking-details-orig">
                                <div className="tracking-details-title-label"> Origin</div>
                                <div className="tracking-details-shipper-consignee-info-wrapper">
                                    <a href={this.getFacilityLink(this.state.shipmentDetails.originCode)} target="_blank">{this.state.shipmentDetails.originCode}</a>
                                </div>
                            </div>

                            <div className="tracking-details-dest">
                                <div className="tracking-details-title-label"> Destination</div>
                                <div className="tracking-details-shipper-consignee-info-wrapper text-uppercase">
                                    <a href={this.getFacilityLink(this.state.shipmentDetails.destinationCode)} target="_blank">{this.state.shipmentDetails.destinationCode}</a>
                                </div>
                            </div>
                            <div className="tracking-details-lot-information">
                                <div className="tracking-details-lot-list-medium-screen-max">
                                    <div className="tracking-details-lot__title">
                                        <p>Delivery Information</p>
                                    </div>
                                    <div className="tracking-details-delivery-information">
                                        <div className="tracking-details-delivery-information-data__row">
                                            <div style={{display: 'table-cell', width: '10%', paddingLeft: '10px'}}>
                                                <div className="tracking-details-delivery-information-data__header_col">
                                                    Lot
                                                </div>
                                            </div>
                                            <div style={{display: 'table-cell', width: '10%'}}>
                                                <div className="tracking-details-delivery-information-data__header_col">
                                                    Pieces
                                                </div>
                                            </div>
                                            <div style={{display: 'table-cell', width: '25%'}}>
                                                <div className="tracking-details-delivery-information-data__header_col">
                                                    On Hand
                                                </div>
                                            </div>
                                            <div style={{display: 'table-cell', width: '25%'}}>
                                                <div className="tracking-details-delivery-information-data__header_col">
                                                    Picked up
                                                </div>
                                            </div>
                                            <div style={{display: 'table-cell', width: '25%'}}>
                                                <div className="tracking-details-delivery-information-data__header_col">
                                                    Signed By
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.props.shipmentDetailsData.routeInformations ? (
                                                this.props.shipmentDetailsData.routeInformations.map(item => {
                                                    return (
                                                            <div key={item.lotNumber}>
                                                                <div className="tracking-details-delivery-information">
                                                                    <div className="tracking-details-delivery-information-data__row">
                                                                        <div style={{display: 'table-cell', width: '10%', paddingLeft: '10px'}}>
                                                                            <div className="tracking-details-delivery-information-data-innercol">
                                                                                {item.lotNumber}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: 'table-cell', width: '10%'}}>
                                                                            <div className="tracking-details-delivery-information-data-innercol">
                                                                                {item.noOfPieces}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: 'table-cell', width: '25%'}}>
                                                                            <div className="tracking-details-delivery-information-data-innercol">
                                                                                {formatDateString(item.receivedDate, "MM/DD/YY")} {getHours(item.receivedDate)} {getAMorPM(item.receivedDate)}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: 'table-cell', width: '25%'}}>
                                                                            <div className="tracking-details-delivery-information-data-innercol">
                                                                                {formatDateString(item.deliveredDate, "MM/DD/YY")} {getHours(item.deliveredDate)} {getAMorPM(item.deliveredDate)}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: 'table-cell', width: '25%'}}>
                                                                            <div className="tracking-details-delivery-information-data-innercol">
                                                                                {item.deliveredToCustomer}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    )
                                                })) : null
                                    }
                                </div>
                            </div>

                            <div className="tracking-details-lot-information">
                                {
                                    this.state.lotInformation ? (
                                            this.state.lotInformation.map(lot => {
                                                return (
                                                        <div key={lot.id}>
                                                            <div className="tracking-details-lot-list-medium-screen-max">
                                                                <div className="tracking-details-lot__title">
                                                                    <p style={{float: "left"}}>{lot.name}: {lot.status}</p>
                                                                    <p style={{float: "right", paddingRight: "10px", color: "#E74C3C"}}>
                                                                        {lot.reroutingReason ? "Rerouted" : null}
                                                                    </p>
                                                                </div>
                                                                <div className="tracking-details-delivery-information">
                                                                    <div className="tracking-details-delivery-information-data__row">
                                                                        <div className="tracking-details-delivery-information-icon">
                                                                            <img src="./assets/icons/shipping.svg" alt="Ship" style={{height: '48px', width: '48px'}}/>
                                                                        </div>
                                                                        <div className="tracking-details-delivery-information-data__col">
                                                                            <div style={{display: 'table', width: '100%'}}>
                                                                                <div className="tracking-details-delivery-information-data__row">
                                                                                    <div className="tracking-details-delivery-information-data__header_col">
                                                                                        Pieces
                                                                                    </div>
                                                                                </div>
                                                                                <div className="tracking-details-delivery-information-data__row">
                                                                                    <div className="tracking-details-delivery-information-data-innercol">
                                                                                        {lot.pieces}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: 'table-cell', width: '30%'}}>
                                                                            <div style={{display: 'table', width: '100%'}}>
                                                                                <div className="tracking-details-delivery-information-data__row">
                                                                                    <div className="tracking-details-delivery-information-data__header_col">
                                                                                        Weight
                                                                                    </div>
                                                                                </div>
                                                                                <div className="tracking-details-delivery-information-data__row">
                                                                                    <div className="tracking-details-delivery-information-data-innercol">
                                                                                        {lot.actualWeight}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: 'table-cell', width: '30%'}}>
                                                                            <div style={{display: 'table', width: '100%'}}>
                                                                                <div className="tracking-details-delivery-information-data__row">
                                                                                    <div className="tracking-details-delivery-information-data__header_col">
                                                                                        &nbsp;
                                                                                    </div>
                                                                                </div>
                                                                                <div className="tracking-details-delivery-information-data__row">
                                                                                    <div className="tracking-details-delivery-information-data-innercol">
                                                                                        &nbsp;
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="tracking-details-lot-details-wrapper__row">
                                                                    <div className="tracking-details-lot-header-seperator"/>
                                                                </div>
                                                                <div className="tracking-details-delivery-information">
                                                                    {lot.flightLegs.map((leg, index) => (
                                                                            <div key={leg.id} className="tracking-details-delivery-information-data__row"
                                                                                 style={{paddingTop: '10px'}}>
                                                                                <div style={{verticalAlign: 'middle', display: 'table-cell', width: '15%'}}>
                                                                                    {index === 0 ?
                                                                                            <img src="./assets/icons/airplane.svg" alt="Ship"
                                                                                                 style={{height: '48px', width: '48px'}}/> : null}
                                                                                </div>
                                                                                <div style={{display: 'table-cell', width: '30%'}}>
                                                                                    <div style={{display: 'table', width: '100%'}}>
                                                                                        <div className="tracking-details-delivery-information-data__row">
                                                                                            <div className="tracking-details-delivery-information-data__header_col">
                                                                                                Flight
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="tracking-details-delivery-information-data__row">
                                                                                        <div className="tracking-details-delivery-information-data-innercol">
                                                                                            {this.getFlightLink(leg)}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{display: 'table-cell', width: '30%'}}>
                                                                                    <div style={{display: 'table', width: '100%'}}>
                                                                                        <div className="tracking-details-delivery-information-data__row">
                                                                                            <div className="tracking-details-delivery-information-data__header_col">
                                                                                                Est. Departure
                                                                                                <div><a href={this.getFacilityLink(leg.origin)} target="_blank">{leg.origin}</a>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="tracking-details-delivery-information-data__row">
                                                                                        <div className="tracking-details-delivery-information-data-innercol">
                                                                                            {formatDateString(leg.estimatedDepart, "MM/DD/YY")} {getHours(leg.estimatedDepart)} {getAMorPM(leg.estimatedDepart)}
                                                                                            <div style={{color: 'gray'}}>Scheduled</div>
                                                                                            <div style={{color: 'gray'}}>{getHours(leg.scheduledDepart)} {getAMorPM(leg.scheduledDepart)}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{display: 'table-cell', width: '30%'}}>
                                                                                    <div style={{display: 'table', width: '100%'}}>
                                                                                        <div className="tracking-details-delivery-information-data__row">
                                                                                            <div className="tracking-details-delivery-information-data__header_col">
                                                                                                Est. Arrival
                                                                                                <div><a href={this.getFacilityLink(leg.destination)}
                                                                                                        target="_blank">{leg.destination}</a></div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="tracking-details-delivery-information-data__row">
                                                                                        <div className="tracking-details-delivery-information-data-innercol">
                                                                                            {formatDateString(leg.estimatedArrival, "MM/DD/YY")} {getHours(leg.estimatedArrival)} {getAMorPM(leg.estimatedArrival)}
                                                                                            <div style={{color: 'gray'}}>Scheduled</div>
                                                                                            <div style={{color: 'gray'}}>{getHours(leg.scheduledArrival)} {getAMorPM(leg.scheduledArrival)}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                    ))}
                                                                </div>
                                                            </div>


                                                            <div className="tracking-details-lot-list-small-screen-only">

                                                                <div className="tracking-details-lot-column-header">
                                                                    <div className="tracking-details-lot-column__header"> Lot</div>
                                                                    <p className="tracking-details-lot-data"> {lot.lotNumber} </p>
                                                                </div>
                                                                <div className="tracking-details-lot-column">
                                                                    <div className="tracking-details-lot-column__header">
                                                                        Status
                                                                    </div>
                                                                    <p className="tracking-details-lot-data"> {lot.status}</p>
                                                                </div>

                                                                {lot.flightLegs.map(leg => (
                                                                        <div key={leg.id} className={this.getCSSForLastLegMobile(leg.isLastLeg)}>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Flight
                                                                                </div>
                                                                                <p className="tracking-details-lot-data"> {leg.flight}</p>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Actual Weight
                                                                                </div>
                                                                                <p className="tracking-details-lot-data">  {lot.actualWeight}
                                                                                    <span className="tracking-details-dimension-unit-of-Measure"> {this.state.lineInformation[0].actualWeightUOM}</span>
                                                                                </p>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Airline Code
                                                                                </div>
                                                                                <p className="tracking-details-lot-data"> {leg.airlineCode} </p>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Flight
                                                                                </div>
                                                                                <p className="tracking-details-lot-data"> {leg.flight} </p>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Origin
                                                                                </div>
                                                                                <p className="tracking-details-lot-data"> {leg.origin} </p>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Dest.
                                                                                </div>
                                                                                <p className="tracking-details-lot-data">{leg.destination} </p>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Sched.
                                                                                </div>
                                                                                <p className="tracking-details-lot-column__header tracking-details-lot-column__subheader">
                                                                                    Departure
                                                                                </p>
                                                                                <div className="tracking-results-column-date-columns">
                                                                                    <div
                                                                                            className="tracking-details-lot-data"> {this.getDateStringFromRawDate(leg.scheduledDepart)} </div>
                                                                                    <div className="tracking-details-lot-data">
                                                                                        {getHours(leg.scheduledDepart)} {getAMorPM(leg.scheduledDepart)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Est.
                                                                                </div>
                                                                                <p className="tracking-details-lot-column__header tracking-details-lot-column__subheader">
                                                                                    Departure
                                                                                </p>
                                                                                <div className="tracking-results-column-date-columns">
                                                                                    <div
                                                                                            className="tracking-details-lot-data"> {this.getDateStringFromRawDate(leg.estimatedDepart)} </div>
                                                                                    <div className="tracking-details-lot-data">
                                                                                        {getHours(leg.estimatedDepart)} {getAMorPM(leg.estimatedDepart)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Sched.
                                                                                </div>
                                                                                <p className="tracking-details-lot-column__header tracking-details-lot-column__subheader">
                                                                                    Arrival
                                                                                </p>
                                                                                <div className="tracking-results-column-date-columns">
                                                                                    <div
                                                                                            className="tracking-details-lot-data"> {this.getDateStringFromRawDate(leg.scheduledArrival)} </div>
                                                                                    <div className="tracking-details-lot-data">
                                                                                        {getHours(leg.scheduledArrival)} {getAMorPM(leg.scheduledArrival)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="tracking-details-lot-column">
                                                                                <div className="tracking-details-lot-column__header">
                                                                                    Est.
                                                                                </div>
                                                                                <p className="tracking-details-lot-column__header tracking-details-lot-column__subheader">
                                                                                    Arrival
                                                                                </p>
                                                                                <div className="tracking-results-column-date-columns">
                                                                                    <div
                                                                                            className="tracking-details-lot-data"> {this.getDateStringFromRawDate(leg.estimatedArrival)} </div>
                                                                                    <div
                                                                                            className="tracking-details-lot-data"> {this.getTimeStringFromRawDate(leg.estimatedArrival)} </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                ))}

                                                                <div className={this.getCSSForLotSepertaorSmallScreen(lot.id)}/>

                                                            </div>
                                                            <div className="tracking-details-lot-seperator"/>
                                                        </div>
                                                )
                                            })) : null
                                }
                            </div>

                        </div>

                    </div>

                    <div className="tracking-details-total-shipment-content-desktop">
                        <div className="tracking-details-total-shipment-label"> Total shipment contents</div>
                        <div
                                className="tracking-details-total-shipment-column__big tracking-details-total-shipment-column__header text-uppercase"> Description
                        </div>
                        <div
                                className="tracking-details-total-shipment-column tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> Pieces
                        </div>
                        <div
                                className="tracking-details-total-shipment-column tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> SLAC*
                        </div>
                        <div
                                className="tracking-details-total-shipment-column tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> Actual
                            WEIGHT
                        </div>
                        <div
                                className="tracking-details-total-shipment-column tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> Length
                        </div>
                        <div
                                className="tracking-details-total-shipment-column tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> Width
                        </div>
                        <div
                                className="tracking-details-total-shipment-column tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> Height
                        </div>
                        <div
                                className="tracking-details-total-shipment-column__big tracking-details-total-shipment-column__header tracking-details-align-center text-uppercase"> Dimensional
                            Weight
                        </div>

                        <div className="tracking-details-total-shipment-seperator"/>

                        {this.state.lineInformation.map(line => (
                                <div className="tracking-details-line-information-row" key={line.id}>
                                    <div
                                            className="tracking-details-total-shipment-column__big tracking-details-total-shipment-data"> {line.description}
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column tracking-details-align-center tracking-details-total-shipment-data"> {line.pieces}
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column tracking-details-align-center tracking-details-total-shipment-data"> {line.slac}
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column tracking-details-align-center tracking-details-total-shipment-data"> {line.actualWeight}
                                        <span className="tracking-details-dimension-unit-of-Measure"> {line.actualWeightUOM}</span>
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column tracking-details-align-center tracking-details-total-shipment-data"> {line.length}
                                        <span className="tracking-details-dimension-unit-of-Measure"> {line.dimensionUnitOfMeasure}</span>
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column tracking-details-align-center tracking-details-total-shipment-data"> {line.width}
                                        <span className="tracking-details-dimension-unit-of-Measure"> {line.dimensionUnitOfMeasure}</span>
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column tracking-details-align-center tracking-details-total-shipment-data"> {line.height}
                                        <span className="tracking-details-dimension-unit-of-Measure"> {line.dimensionUnitOfMeasure}</span>
                                    </div>
                                    <div
                                            className="tracking-details-total-shipment-column__big tracking-details-align-center tracking-details-total-shipment-data"> {line.dimensionalWeight}
                                        <span
                                                className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                    </div>
                                </div>
                        ))}

                        <div className="tracking-details-total-shipment-seperator"/>
                        <div className="tracking-details-total-shipment-total-wrapper">
                            <div className="tracking-details-total-shipment-column__big"> Total</div>
                            <div
                                    className="tracking-details-total-shipment-column tracking-details-align-center"> {this.state.lineInfoTotals.totalPieces}</div>
                            <div className="tracking-details-total-shipment-column tracking-details-align-center"> {this.state.lineInfoTotals.totalSlac}</div>
                            <div
                                    className="tracking-details-total-shipment-column tracking-details-total-shipment-less-spaced-columns tracking-details-align-center ">
                                {this.state.lineInfoTotals.totalActualWeight}
                                <span
                                        className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                <span className="tracking-details-superscript">
                {this.state.lineInfoTotals.totalActualWeight > this.state.lineInfoTotals.totalDimensionalWeight ? "*" : ""}
              </span>
                            </div>
                            <div className="tracking-details-total-shipment-column"/>
                            <div className="tracking-details-total-shipment-column"/>
                            <div className="tracking-details-total-shipment-column"/>
                            <div
                                    className="tracking-details-total-shipment-column__big tracking-details-align-center"> {this.state.lineInfoTotals.totalDimensionalWeight}
                                <span
                                        className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                <span className="tracking-details-superscript">
                {this.state.lineInfoTotals.totalDimensionalWeight > this.state.lineInfoTotals.totalActualWeight ? "*" : ""}
              </span>
                            </div>
                        </div>

                    </div>

                    < div className="tracking-details-total-shipment-content-medium-small-screen">
                        <div className="tracking-details-total-shipment-label"> Total shipment contents</div>
                        <div className="tracking-details-total-shipment-inner-content">
                            {this.state.lineInformation.map(line => (
                                    <div className="tracking-details-total-shipment-content-medium-small-screen" key={line.id}>
                                        <div className="tracking-details-total-shipment-description-label text-uppercase">
                                            Shipment Description
                                        </div>
                                        <div className="tracking-details-total-shipment-description-name">
                                            {line.description}
                                        </div>

                                        <div className="tracking-details-total-shipment-row">
                                            <div className="tracking-details-total-shipment-column text-uppercase">
                                                Pieces
                                                <p className="tracking-details-total-shipment-data"> {line.pieces} </p>
                                            </div>
                                            <div className="tracking-details-total-shipment-column text-uppercase">
                                                Actual Weight
                                                <p className="tracking-details-total-shipment-data">{line.actualWeight} <span
                                                        className="tracking-details-dimension-unit-of-Measure"> {line.actualWeightUOM}</span></p>
                                            </div>
                                            <div className="tracking-details-total-shipment-column text-uppercase">
                                                Dimensional Weight
                                                <p className="tracking-details-total-shipment-data"> {line.dimensionalWeight} <span
                                                        className="tracking-details-dimension-unit-of-Measure"> {line.actualWeightUOM}</span></p>
                                            </div>
                                        </div>

                                        <div className="tracking-details-total-shipment-row">
                                            <div className="tracking-details-total-shipment-column text-uppercase">
                                                Length
                                                <p className="tracking-details-total-shipment-data"> {line.length} <span
                                                        className="tracking-details-dimension-unit-of-Measure"> {line.dimensionUnitOfMeasure}</span></p>
                                            </div>
                                            <div className="tracking-details-total-shipment-column text-uppercase">
                                                Width
                                                <p className="tracking-details-total-shipment-data">{line.width} <span
                                                        className="tracking-details-dimension-unit-of-Measure"> {line.dimensionUnitOfMeasure}</span></p>
                                            </div>
                                            <div className="tracking-details-total-shipment-column text-uppercase">
                                                Height
                                                <p className="tracking-details-total-shipment-data"> {line.height} <span
                                                        className="tracking-details-dimension-unit-of-Measure"> {line.dimensionUnitOfMeasure}</span></p>
                                            </div>
                                        </div>

                                        <div className="tracking-details-lot-seperator"/>

                                    </div>
                            ))}

                            <div className="tracking-details-total-shipment-total-wrapper">
                                <div className="tracking-details-total-shipment-footer-total-label"> Total</div>
                                <div className="tracking-details-total-shipment-row">
                                    <div className="tracking-details-total-shipment-footer-column text-uppercase">
                                        Pieces
                                        <div
                                                className="tracking-details-total-shipment-footer-data"> {this.state.lineInfoTotals.totalPieces} </div>
                                    </div>
                                    <div className="tracking-details-total-shipment-footer-column text-uppercase">
                                        Actual Weight
                                        <div
                                                className="tracking-details-total-shipment-footer-data"> {this.state.lineInfoTotals.totalActualWeight}
                                            <span
                                                    className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                            <span className="tracking-details-superscript">
                       {this.state.lineInfoTotals.totalActualWeight > this.state.lineInfoTotals.totalDimensionalWeight ? "*" : ""}
                    </span>
                                        </div>
                                    </div>
                                    <div className="tracking-details-total-shipment-footer-column text-uppercase">
                                        Dimensional Weight
                                        <div
                                                className="tracking-details-total-shipment-footer-data">{this.state.lineInfoTotals.totalDimensionalWeight}
                                            <span
                                                    className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                            <span className="tracking-details-superscript">
                       {this.state.lineInfoTotals.totalDimensionalWeight > this.state.lineInfoTotals.totalActualWeight ? "*" : ""}
                    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tracking-details-total-shipment-total-wrapper-small-screen">
                                <div className="tracking-details-total-shipment-footer-total-label"> Total</div>
                                <div className="tracking-details-total-shipment-row">
                                    <div className="tracking-details-total-shipment-footer-column text-uppercase">
                                        Pieces
                                        <p
                                                className="tracking-details-total-shipment-footer-data"> {this.state.lineInfoTotals.totalPieces} </p>
                                    </div>
                                    <div className="tracking-details-total-shipment-footer-span-two-columns text-uppercase">
                                        Actual Weight
                                        <div
                                                className="tracking-details-total-shipment-footer-data"> {this.state.lineInfoTotals.totalActualWeight}
                                            <span
                                                    className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                            <span className="tracking-details-superscript">
                       {this.state.lineInfoTotals.totalActualWeight > this.state.lineInfoTotals.totalDimensionalWeight ? "*" : ""}
                    </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tracking-details-total-shipment-row">
                                    <div className="tracking-details-total-shipment-footer-column__big text-uppercase">
                                        Dimensional Weight
                                        <p
                                                className="tracking-details-total-shipment-footer-data">{this.state.lineInfoTotals.totalDimensionalWeight}
                                            <span
                                                    className="tracking-details-total-shipment-footer-data__uom"> {this.state.lineInfoTotals.totalActualWeightUOM} </span>
                                            <span className="tracking-details-superscript">
                       {this.state.lineInfoTotals.totalDimensionalWeight > this.state.lineInfoTotals.totalActualWeight ? "*" : ""}
                    </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="tracking-details-chargeable-weight-disclaimer">
                        <span className="tracking-details-superscript-same-size-font">*</span> SLAC (shippers load stow and count).
                        <p/>
                        <span className="tracking-details-superscript-same-size-font">*</span> Chargeable weight used for shipping
                        cost.
                        <p/>
                        For more information or assistance with tracking international shipments, please contact the Cargo Customer
                        Care Center at 1 (800) 533-1222.
                    </div>

                    <BackgroundColorMobile/>

                </div>
        )
    }
}

TrackingDetails.propTypes = {
    shipmentDetailsData: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    shipmentDetailsData: state.shipmentDetails.item,
    rawFacilities: state.facilitiesData.rawFacilities
});

const mapDispatchToProps = dispatch => ({
    requestShipmentDetailsData: data => {
        dispatch(requestShipmentDetailsData(data));
    },
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA})
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrackingDetails));



// WEBPACK FOOTER //
// ./src/components/TrackingDetails/TrackingDetails.js